export default "__VITE_ASSET__sBLFKKQU__"